module.exports = __webpack_public_path__ + "img/complete-bilingual-solution.47eb1193.png";